export enum ToastPositionEnum {
	INLINE = 'inline',
	SMALL_TOP = 'toast-top-center',
	SMALL_CENTER = 'toast-center-center',
	SMALL_BOTTOM = 'toast-bottom-center',
	LARGE_TOP = 'toast-top-full-width',
	LARGE_BOTTOM = 'toast-bottom-full-width'
}
